/** Dispatched when a keyboard shortcut drives the camera so the HUD can match highlights. */
export const CAMERA_VIEW_MENU_SHORTCUT_PULSE_EVENT = "critter-camera-view-menu-shortcut-pulse";

/**
 * @typedef {{ kind: "orthogonal", key: string } | { kind: "reset" } | { kind: "focus" } | { kind: "fit" }} CameraViewMenuShortcutPulseDetail
 */

export function blurFocusInsideCameraViewMenu() {
  const root = document.querySelector(".camera-view-menu");
  const ae = document.activeElement;
  if (!root || !ae || !root.contains(ae)) return;
  if (typeof ae.blur === "function") ae.blur();
}

/** Brief UI pulse so the floating camera menu reflects keyboard-driven camera actions. */
export function pulseCameraViewMenuShortcut(detail) {
  blurFocusInsideCameraViewMenu();
  window.dispatchEvent(new CustomEvent(CAMERA_VIEW_MENU_SHORTCUT_PULSE_EVENT, { detail }));
}
